import { connect } from 'react-redux'
import ContextMenu from './context-menu'
import { copyExample } from '../../../../../../../stores/examples/examples.actions'
import { getExample } from '../../../../../../../stores/examples/examples.selectors'
import { withRouter } from 'react-router-dom'

const mapStateToProps = (state, { id, history }) => {
  const file = getExample(state, id)
  return {
    id: file.id
  }
}

const mapDispatchToProps = dispatch => ({ dispatch })

const mergeProps = (stateProps, { dispatch }, ownProps) => ({
  ...stateProps,
  ...ownProps,
  onCopy: () => {
    return dispatch(copyExample(ownProps.id)).then(() =>
      ownProps.history.push('/my-files')
    )
  }
})

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps, mergeProps)(ContextMenu)
)
